export default __webpack_public_path__ + "static/media/checkBox.e718dbb5.svg";